// extracted by mini-css-extract-plugin
export default {"container":"InputControl_container__7uRrc","input1":"InputControl_input1__3mx0v"};